import styled from 'styled-components'
import { TabsName } from '../../../../constants'

const Wrapper = styled.div`
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  position: relative;
  /* min-height: 240px; */
  min-height: clamp(12.188rem, -0.867rem + 16.13vw, 15rem);

  [class^='swiper-button-'] {
    --size: 35px;
    appearance: none;
    padding: 0;
    position: absolute;
    top: 50%;
    z-index: 10;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: opacity 0.3s;
    width: var(--size);
    height: 100%;
    font-size: var(--size);
    color: ${({ tab }) => (tab === TabsName.NISSOKEN_COURSE ? '#0080cf' : '#760076')};

    &:hover {
      opacity: 0.8;
    }

    &.swiper-button-disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }

  .swiper-button-prev {
    left: 0;
    transform: translate(-100%, -50%);
  }

  .swiper-button-next {
    right: 0;
    transform: translate(100%, -50%);
  }
`

export default Wrapper
